import React from "react";
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { all_routes } from "../../../Router/all_routes";
import { base_api_url } from "../../../environment.jsx";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { useEffect, useState, useRef } from 'react';
import withReactContent from "sweetalert2-react-content";
import PropTypes from 'prop-types';
import { Image } from 'react-feather';
import './AddArticlesDrawer.css';


const AddArticles = ({ show, onFormSubmit, onClose, editMode = false, articleData = null }) => {

    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const [categorie, setcategorie] = useState([]);
    const [etiquettes, setEtiquettes] = useState([]);
    const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;

    //pour recuprer les elements du formulaire
    const [formData, setFormData] = useState({
        "nom": "",
        "prix_unitaire": "",
        "description": "",
        "quantite_defaut": "",
        "image_url": "",
        "id_restaurant": ideresto,
        "id_categorie": null,
        "disponible": true,
        "etiquette": ""
    });

    // Use Effect pour populate le formulaire en mode édition
    useEffect(() => {
        if (editMode && articleData) {
            setFormData({
                nom: articleData.nom || "",
                prix_unitaire: articleData.prix_unitaire || "",
                description: articleData.description || "",
                quantite_defaut: articleData.quantite || "",
                image_url: articleData.image_url || "",
                id_restaurant: ideresto,
                id_categorie: articleData.categorie?.[0]?.id_categorie || null,
                disponible: articleData.disponible ?? true,
                etiquette: articleData.etiquette || ""
            });
            if (articleData.image_url) {
                setLogo(articleData.image_url);
            }
        }
    }, [editMode, articleData, ideresto]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const imageRef = useRef();

    const resetForm = () => {
        imageRef.current.value = "";
        setLogo("");
        setFormData({
            nom: "",
            prix_unitaire: "",
            description: "",
            quantite_defaut: "",
            id_categorie: "",
            etiquette: "",
            disponible: true
        });
    };

    const route = all_routes;
    const navigate = useNavigate();

    useEffect(() => {
        fetchCategories();
        fetchEtiquettes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // pour le chargement des categories
    const fetchCategories = async () => {
        const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
        try {
            const response = await axios.get(`${base_api_url}api/categorie/${ideresto}`);

            setcategorie(response.data.categorie); // stocker toutes les catégories
            console.log("Catégories chargées :", response.data.categorie);
        } catch (error) {
            console.error("Error fetching categories:", error);

            //             let errorTitle = "Erreur de chargement des catégories";
            let errorMessage = "Impossible de charger les catégories.";

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 401:
                        //                         errorTitle = "Session expirée";
                        errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
                        break;

                    case 404:
                        //                         errorTitle = "Catégories introuvables";
                        errorMessage = "Aucune catégorie trouvée pour ce restaurant.";
                        break;

                    case 500:
                        //                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur lors du chargement des catégories.";
                        break;

                    default:
                        //                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des catégories.";
                }
            } else if (error.request) {
                //                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur pour charger les catégories.";
            }

            // Show error toast
            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });

            // Set empty array on error
            setcategorie([]);
        }
    };

    // pour la soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault(); // éviter le rechargement de la page
        setLoading(true);
        try {
            const token = JSON.parse(localStorage.getItem("user"))?.access_token;
            const id_utilisateur = JSON.parse(localStorage.getItem("user"))?.id_utilisateur;
            console.log("Form data to submit:", formData);

            // Upload image to S3 first if a new image was selected
            let imageFileName = formData.image_url;
            if (logo && logo.startsWith('blob:')) {
                // Convert blob URL to file and upload
                const imageFile = imageRef.current.files[0];
                if (imageFile) {
                    console.log("Uploading image file:", imageFile.name);
                    const imageFormData = new FormData();
                    imageFormData.append('file', imageFile);
                    imageFormData.append('nomtableconcerner', 'article');
                    imageFormData.append('iduser', id_utilisateur);

                    try {
                        const imageUploadResponse = await axios.post(
                            `${base_api_url}api/envoyer_image`,
                            imageFormData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                    Authorization: `Bearer ${token}`,
                                },
                            }
                        );

                        if (imageUploadResponse.data.nom_image) {
                            imageFileName = imageUploadResponse.data.nom_image;
                            console.log("Image uploaded successfully:", imageFileName);
                        }
                    } catch (imageError) {
                        console.error("Error uploading image:", imageError);
                        throw new Error("Échec du téléchargement de l'image. Veuillez réessayer.");
                    }
                }
            }

            // Update formData with the image filename
            // Only submit: nom, prix_unitaire, id_categorie, etiquette, image_url
            const submissionData = {
                nom: formData.nom,
                prix_unitaire: formData.prix_unitaire,
                id_categorie: formData.id_categorie,
                etiquette: formData.etiquette,
                image_url: imageFileName.replace(`${base_api_url}api/recuperer/`, ''),
                id_restaurant: ideresto
            };

            let response;
            if (editMode && articleData?.id_article) {
                // Update existing article
                response = await axios.put(`${base_api_url}api/article/${articleData.id_article}`,
                    submissionData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                console.log("Article updated:", response.data);
            } else {
                // Create new article
                response = await axios.post(`${base_api_url}api/article`,
                    submissionData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                console.log("mes données:", submissionData);
            }

            // Handle successful responses (200, 201)
            if (response.status === 200 || response.status === 201) {
                // Show success toast
                MySwal.fire({
                    icon: "success",
                    // title: editMode ? "Mise à jour réussie !" : "Enregistrement réussi !",
                    text: editMode ? "L'article a été modifié avec succès." : "L'article a été créé avec succès.",
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    customClass: {
                        popup: "pixel-toast",
                    },
                });

                // Reset form and close modal
                resetForm();
                onFormSubmit();
                onClose();

                // Save article data and navigate (only for new articles)
                if (!editMode) {
                    localStorage.setItem("article", JSON.stringify(response.data));
                    setTimeout(() => {
                        navigate(route.articlesNew);
                    }, 3000);
                }
            }

        } catch (error) {
            console.log("Error details:", error.response?.data || error.message);

            //          let errorTitle = "Erreur";
            let errorMessage = error.message || "Une erreur s'est produite. Veuillez réessayer.";

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 400:
                        //                errorTitle = "Données invalides";
                        if (errorData?.message?.includes("nom")) {
                            errorMessage = "Le nom de l'article est requis et ne peut pas être vide.";
                        } else if (errorData?.message?.includes("prix_unitaire")) {
                            errorMessage = "Le prix unitaire est requis et doit être un nombre valide.";
                        } else {
                            errorMessage = errorData?.message || "Les données saisies ne sont pas valides. Vérifiez que tous les champs requis sont remplis correctement.";
                        }
                        break;

                    case 401:
                        //                errorTitle = "Accès non autorisé";
                        errorMessage = "Votre session a expiré. Veuillez vous reconnecter pour continuer.";
                        setTimeout(() => {
                            navigate(route.signin);
                        }, 2000);
                        break;

                    case 402: {
                        //                errorTitle = "Champs requis manquants";
                        const missingFields = [];
                        if (!formData.nom || formData.nom.trim() === "") missingFields.push("nom");
                        if (!formData.prix_unitaire || formData.prix_unitaire <= 0) missingFields.push("prix unitaire");

                        if (missingFields.length > 0) {
                            errorMessage = `Les champs suivants sont requis : ${missingFields.join(", ")}.`;
                        } else {
                            errorMessage = "Veuillez remplir tous les champs obligatoires : nom et prix unitaire.";
                        }
                        break;
                    }

                    case 404:
                        //                errorTitle = editMode ? "Article introuvable" : "Ressource introuvable";
                        errorMessage = editMode
                            ? "L'article que vous tentez de modifier n'existe plus ou a été supprimé."
                            : "La ressource demandée est introuvable. Veuillez actualiser la page et réessayer.";
                        break;

                    case 409:
                        //                errorTitle = "Conflit de données";
                        errorMessage = "Un article avec ce nom existe déjà. Veuillez choisir un nom différent.";
                        break;

                    case 422:
                        //                errorTitle = "Données non valides";
                        errorMessage = errorData?.message || "Les données saisies ne respectent pas le format requis.";
                        break;

                    case 500:
                        //                errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer dans quelques instants.";
                        break;

                    case 503:
                        //                errorTitle = "Service temporairement indisponible";
                        errorMessage = "Le service est temporairement indisponible. Veuillez réessayer dans quelques minutes.";
                        break;

                    default:
                        //                errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || `Une erreur inattendue s'est produite (Code: ${status}).`;
                }
            } else if (error.request) {
                //            errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet et réessayez.";
            }

            // Show error toast
            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        } finally {
            setLoading(false);
        }
    };

    const [logo, setLogo] = useState(null);

    const fetchEtiquettes = async () => {
        const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
        const token = JSON.parse(localStorage.getItem("user"))?.access_token;

        try {
            const response = await axios.get(`${base_api_url}api/etiquette/${ideresto}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setEtiquettes(response.data.etiquette || []);
            console.log("Étiquettes chargées :", response.data.etiquette);
        } catch (error) {
            console.error("Error fetching etiquettes:", error);

            //             let errorTitle = "Erreur de chargement des étiquettes";
            let errorMessage = "Impossible de charger les étiquettes.";

            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;

                switch (status) {
                    case 401:
                        //                         errorTitle = "Session expirée";
                        errorMessage = "Votre session a expiré. Veuillez vous reconnecter.";
                        break;

                    case 404:
                        //                         errorTitle = "Étiquettes introuvables";
                        errorMessage = "Aucune étiquette trouvée pour ce restaurant.";
                        break;

                    case 500:
                        //                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur lors du chargement des étiquettes.";
                        break;

                    default:
                        //                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || "Une erreur inattendue s'est produite lors du chargement des étiquettes.";
                }
            } else if (error.request) {
                //                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur pour charger les étiquettes.";
            }

            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });

            setEtiquettes([]);
        }
    };

    return (
        <>
            {/* Backdrop */}
            {show && (
                <div
                    className={`drawer-backdrop ${show ? 'show' : ''}`}
                    onClick={onClose}
                ></div>
            )}

            {/* Drawer */}
            <div className={`article-drawer ${show ? 'show' : ''}`}>
                <form onSubmit={handleSubmit}>
                    {/* Header */}
                    <div className="drawer-header">
                        <h4>{editMode ? "Modifier l'article" : "Ajouter un article"}</h4>
                        <button
                            type="button"
                            className="drawer-close-btn"
                            onClick={() => {
                                resetForm();
                                onClose();
                            }}
                        >
                            ×
                        </button>
                    </div>

                    {/* Body */}
                    <div className="drawer-body">
                        {/* Section: Informations générales */}
                        <div className="drawer-section-header">Informations générales</div>

                        {/* Nom de l'article */}
                        <div className="drawer-form-group">
                            <label className="drawer-label drawer-label-required">
                                Nom de l&apos;article
                            </label>
                            <input
                                type="text"
                                name="nom"
                                value={formData.nom}
                                onChange={handleChange}
                                required
                                className="drawer-input"
                                placeholder="Ex: Poulet DG"
                            />
                        </div>

                        {/* Description */}
                        <div className="drawer-form-group">
                            <label className="drawer-label">
                                Description
                            </label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                className="drawer-textarea"
                                placeholder="Description du plat..."
                            />
                        </div>

                        {/* Row: Catégorie & Sous-catégorie (disabled) */}
                        <div className="drawer-row">
                            <div className="drawer-col">
                                <div className="drawer-label-row">
                                    <label className="drawer-label drawer-label-required">
                                        Catégorie racine
                                    </label>
                                    {categorie.length === 0 && (
                                        <Link
                                            to="/plat-category"
                                            className="drawer-link-btn"
                                            onClick={() => onClose()}
                                        >
                                            Créer une catégorie
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M7 17L17 7" />
                                                <path d="M7 7h10v10" />
                                            </svg>
                                        </Link>
                                    )}
                                </div>
                                <select
                                    name="id_categorie"
                                    className="drawer-select"
                                    value={formData.id_categorie || ""}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">
                                        {categorie.length === 0 ? "Aucune catégorie disponible" : "Sélectionner"}
                                    </option>
                                    {categorie.map((cat) => (
                                        <option key={cat.id} value={cat.id}>
                                            {cat.nom}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* <div className="drawer-col">
                                <label className="drawer-label drawer-label-required">
                                    Sous-catégorie
                                </label>
                                <select
                                    className="drawer-select"
                                    disabled
                                >
                                    <option>Sélectionner</option>
                                </select>
                                <span className="drawer-hint">Fonctionnalité à venir</span>
                            </div> */}
                        </div>

                        {/* Image du plat */}
                        <div className="drawer-form-group">
                            <label className="drawer-label">Image du plat</label>

                            {/* <div className="drawer-info-box">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10"/>
                                    <line x1="12" y1="16" x2="12" y2="12"/>
                                    <line x1="12" y1="8" x2="12.01" y2="8"/>
                                </svg>
                                <span className="drawer-info-text">
                                    Les images doivent représenter des plats africains authentiques (camerounais, ivoiriens, congolais, sénégalais, etc.)
                                </span>
                            </div> */}

                            <div
                                className="drawer-upload-area"
                                onClick={() => imageRef.current?.click()}
                            >
                                <div className="drawer-upload-icon">
                                    <Image size={32} />
                                </div>
                                <div className="drawer-upload-text">
                                    Cliquez pour ajouter une image
                                </div>
                                <div className="drawer-upload-hint">
                                    PNG, JPG jusqu&apos;à 1 Mo
                                </div>
                            </div>

                            <input
                                type="file"
                                accept="image/*"
                                className="drawer-upload-input"
                                ref={imageRef}
                                onChange={e => {
                                    if (e.target.files && e.target.files[0]) {
                                        const file = e.target.files[0];
                                        setLogo(URL.createObjectURL(file));
                                        console.log("Fichier sélectionné :", file.name);
                                        setFormData((prevData) => ({
                                            ...prevData,
                                            image_url: URL.createObjectURL(file),
                                        }));
                                    }
                                }}
                            />

                            {logo && (
                                <div className="drawer-image-preview">
                                    <img src={logo} alt="Aperçu" />
                                </div>
                            )}
                        </div>

                        {/* Section: Prix & disponibilité */}
                        <div className="drawer-section-header">Prix & disponibilité</div>

                        <div className="drawer-form-group">
                            <label className="drawer-label drawer-label-required">
                                Prix (EUR)
                            </label>
                            <input
                                type="number"
                                step="0.01"
                                name="prix_unitaire"
                                value={formData.prix_unitaire}
                                onChange={handleChange}
                                required
                                className="drawer-input"
                                placeholder="0.00"
                            />
                        </div>

                        {/* <div className="drawer-form-group">
                            <div className="drawer-label-row">
                                <label className="drawer-label">
                                    Disponible à la vente
                                </label>
                                <label className="drawer-toggle">
                                    <input
                                        type="checkbox"
                                        checked={formData.disponible}
                                        onChange={(e) => setFormData({...formData, disponible: e.target.checked})}
                                    />
                                    <span className="drawer-toggle-slider"></span>
                                </label>
                            </div>
                        </div> */}

                        {/* <div className="drawer-form-group">
                            <label className="drawer-label drawer-label-required">
                                Disponibilité
                            </label>
                            <div className="drawer-checkbox-group">
                                <div className="drawer-checkbox-item">
                                    <input type="checkbox" id="sur-place" defaultChecked disabled />
                                    <label htmlFor="sur-place">Sur place</label>
                                </div>
                                <div className="drawer-checkbox-item">
                                    <input type="checkbox" id="a-emporter" disabled />
                                    <label htmlFor="a-emporter">À emporter</label>
                                </div>
                                <div className="drawer-checkbox-item">
                                    <input type="checkbox" id="livraison" disabled />
                                    <label htmlFor="livraison">Livraison</label>
                                </div>
                            </div>
                            <span className="drawer-hint">Options de disponibilité (à titre indicatif)</span>
                        </div> */}

                        {/* Section: Préparation */}
                        <div className="drawer-section-header">Préparation</div>

                        <div className="drawer-form-group">
                            <div className="drawer-label-row">
                                <label className="drawer-label">
                                    Étiquette de préparation
                                </label>
                                {etiquettes.length === 0 && (
                                    <Link
                                        to="/etiquettes"
                                        className="drawer-link-btn"
                                        onClick={() => onClose()}
                                    >
                                        Créer une étiquette
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <path d="M7 17L17 7" />
                                            <path d="M7 7h10v10" />
                                        </svg>
                                    </Link>
                                )}
                            </div>
                            <select
                                name="etiquette"
                                className="drawer-select"
                                value={formData.etiquette || ""}
                                onChange={handleChange}
                            >
                                <option value="">
                                    {etiquettes.length === 0 ? "Aucune étiquette disponible" : "Aucune"}
                                </option>
                                {etiquettes.map((etiq) => (
                                    <option key={etiq.id_etiquette} value={etiq.code}>
                                        {etiq.code}
                                    </option>
                                ))}
                            </select>
                            <span className="drawer-hint">
                                Détermine sur quel écran de préparation les plats apparaîtront (Cuisine ou Bar)
                            </span>
                        </div>

                        {/* Section: Ingrédients - Mis en commentaire à la demande */}
                        {/* 
                        <div className="drawer-section-header">Ingrédients</div>

                        <div className="drawer-form-group">
                            <button
                                type="button"
                                className="drawer-btn drawer-btn-secondary"
                                style={{ width: 'auto', padding: '8px 16px' }}
                                disabled
                            >
                                + Ajouter
                            </button>
                            <span className="drawer-hint">
                                Ajoutez les ingrédients utilisés pour ce plat afin de suivre automatiquement le stock (fonctionnalité à venir)
                            </span>
                        </div>
                        */}

                        {formData.quantite_defaut && (
                            <div className="drawer-form-group" style={{ display: 'none' }}>
                                <input
                                    type="number"
                                    name="quantite_defaut"
                                    value={formData.quantite_defaut}
                                    onChange={handleChange}
                                />
                            </div>
                        )}
                    </div>

                    {/* Footer */}
                    <div className="drawer-footer">
                        <button
                            type="button"
                            className="drawer-btn drawer-btn-secondary"
                            onClick={() => {
                                resetForm();
                                onClose();
                            }}
                        >
                            Annuler
                        </button>
                        <button
                            type="submit"
                            className="drawer-btn drawer-btn-primary"
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="drawer-spinner"></span>
                                    {editMode ? "Mise à jour..." : "Enregistrement..."}
                                </>
                            ) : (
                                editMode ? "Enregistrer les modifications" : "Créer l'article"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}

AddArticles.propTypes = {
    onFormSubmit: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    editMode: PropTypes.bool,
    articleData: PropTypes.object
};

export default AddArticles
